import PropTypes from "prop-types";
import PieChart from "./PieChart";

function EstadosEstudiantesChart({ data }) {
  return (
    <PieChart
      data={data}
      title="Estados de Estudiantes Atendidos"
      height={300}
      legendPosition="right"
      showPercentage={true}
      responsiveLegend={true}
    />
  );
}

EstadosEstudiantesChart.propTypes = {
  data: PropTypes.shape({
    labels: PropTypes.arrayOf(PropTypes.string),
    data: PropTypes.arrayOf(PropTypes.number),
  }),
};

export default EstadosEstudiantesChart;
